/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import openSystemPush$1 from './cn/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../promise-windvane-85486cec.js';

/**
 * 开启系统通知。支持【菜鸟App】
 * SDK: https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
 * @example
 * import { openSystemPush } from '@alife/cn-uni-api';
 *
 * openSystemPush()
 *  .then((res) => {
      doSomeMtop();
 *  });
 *  .catch(err => Toast.show('开启提醒失败'))
 *
 * @author 敬文
 */
var openSystemPush = extend({
    web: {
        windvane: {
            cn: openSystemPush$1,
        },
    },
});

export { openSystemPush };
